import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatMoney } from "@bw/shared/utils";
import type { ModuleReceiptHistoryProps } from "./companyReceiptContracts";
import { receiptOriginal } from "./useModuleReceipts";

export function ModuleReceiptHistory({ page, selectedPurchaseId, selectedReceiptId, readDisabled, onView, onPage }: ModuleReceiptHistoryProps) {
  if (page.purchase_id !== selectedPurchaseId) return null;
  return <Stack spacing={1.5} aria-label="Recorded company payments">
    <Typography component="h3" variant="subtitle1">Recorded payments</Typography>
    {!page.items.length ? <Typography>No recorded payments returned.</Typography> : page.items.map(item => <Stack key={item.receipt_id} spacing={0.5}>
      <Typography>{formatMoney(item.collected_amount.amount_minor / 100, item.collected_amount.currency)} recorded {new Date(item.recorded_at).toLocaleString()}</Typography>
      <Button size="small" sx={{ alignSelf: "flex-start" }} disabled={readDisabled} variant={selectedReceiptId === item.receipt_id ? "outlined" : "text"}
        onClick={() => { if (!readDisabled) onView(receiptOriginal(item)); }}>View receipt</Button>
    </Stack>)}
    <Stack direction="row" spacing={1}>
      <Button size="small" aria-label="Previous payments" disabled={readDisabled || page.offset === 0}
        onClick={() => { if (!readDisabled) onPage(Math.max(0, page.offset - page.limit)); }}>Previous</Button>
      <Button size="small" aria-label="Next payments" disabled={readDisabled || page.offset + page.items.length >= page.total}
        onClick={() => { if (!readDisabled) onPage(page.offset + page.limit); }}>Next</Button>
    </Stack>
  </Stack>;
}
